<script setup lang="ts">

import {computed, defineAsyncComponent} from 'vue'
import {FormItemProps} from ".";
import {useForwardProps} from 'radix-vue'
import {SelectGroup, SelectItem} from "@/shared/components/ui/select";
import {Country} from "@/shared/graphql/types";
import FormSelect from "@/shared/components/ui/form2/element/FormSelect.vue";

interface FormSelectProps extends FormItemProps {
  placeholder?: string,
  countries: Country[],
}

const props = defineProps<FormSelectProps>()
const AsyncCountryFlag = defineAsyncComponent(async () => {
  const module = (await import('vue-country-flag-next'))
  return module.default
});

const delegatedProps = computed(() => {
  const {class: _, ...delegated} = props

  return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <FormSelect v-bind="forwardedProps" :class="props.class">
    <SelectGroup>
      <SelectItem v-for="(country) in countries" :key="country.code.toString()" :value="country.code.toString()" :object="country" :id="country.code" :label="country.label">
          <span class="flex flex-row justify-start gap-1 items-center">
            <AsyncCountryFlag :country="country.code" size="small"/> {{ country.label }}
          </span>
      </SelectItem>
    </SelectGroup>
  </FormSelect>
</template>

<style scoped>

</style>